import { render, staticRenderFns } from "./PersonalInfoModal.vue?vue&type=template&id=6c67a67b&"
import script from "./PersonalInfoModal.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports